import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [hideBottomNavigation, setHideBottomNavigation] = useState(false);
  // Set by the profile bottom bar (see useScrollHideProgress) while it is scrolled out of view
  const [navScrollHidden, setNavScrollHidden] = useState(false);
  const isNavScrollHidden = navScrollHidden && !hideBottomNavigation;

  return (
    <NavigationContext.Provider value={{
      hideBottomNavigation,
      setHideBottomNavigation,
      isNavScrollHidden,
      setNavScrollHidden
    }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export default NavigationContext;
